import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingService } from './billing.service';
import { BillingCentralModule } from './billing-central/billing-central.module';
import { BillingUnitModule } from './billing-unit/billing-unit.module';
import { BillingPaymentModule } from './billing-payment/billing-payment.module';
import { BillingCompanyInformationModule } from './billing-company-information/billing-company-information.module';
import { BillingHeaderComponent } from './billing-header/billing-header.component';
import { ComponentsModule } from '../components/components.module';
import { UtilitiesModule } from '../utilities/utilities.module';
import { BillingComponentsModule } from './billing-components/billing-components.module';
import { UIRouterModule } from '@uirouter/angular';
import { BillingStates } from '@fi-app/billing/billing-states';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        UtilitiesModule,
        BillingCentralModule,
        BillingUnitModule,
        BillingPaymentModule,
        BillingCompanyInformationModule,
        BillingComponentsModule,
        UIRouterModule.forChild(BillingStates),
        FiButtonBackNewModule,
    ],
    declarations: [BillingHeaderComponent],
    providers: [BillingService],
})
export class BillingModule {}
